import siteConfig from "../variables";

function logger(message: string, error?: Error, type = "log", context: object = {}): void {
  if (siteConfig.BUILD_ENV !== "production") {
    // Log types
    const log = (
      {
        log: console.log,
        warn: console.warn,
        error: console.error,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any
    )[type];

    log(`${message}: ${error}`);
  }
  //@TODO: Where to log in production?
  if (error && typeof window !== "undefined") {
    window.newrelic?.noticeError(error, {
      ...context,
      message,
      type,
    });
  }
}

export default logger;
